const ApiService = require('ceres/app/services/ApiService');
const NotificationService = require('ceres/app/services/NotificationService');

import TranslationService from 'ceres/app/services/TranslationService';

Vue.component('checkout-guest-mail-login', {

    props: [
        'template'
    ],

    data() {
        return {
            guestMail: '',
            guestMailDisabled: false,
            noGuestMail: true,
            isChange: false
        };
    },

    computed: {
        ...Vuex.mapState({
            user: state => state.user
        }),
        ...Vuex.mapGetters([
            'isLoggedIn'
        ])
    },

    created() {

        this.$options.template = this.template;

        if (!this.isLoggedIn) {
            ApiService
                .get('/rest/fashioncode/guest')
                .done(function (response) {

                    if (typeof response !== 'undefined' && response.data !== null) {
                        this.guestMail = response;
                        this.noGuestMail = false;
                    }

                    this.handleDocumentReady();

                }.bind(this))
        } else {
            this.handleDocumentReady();
        }

    },

    methods: {

        handleDocumentReady() {

            let that = this;

            $('document').ready(function () {

                if (that.isLoggedIn || !that.noGuestMail) {
                    $('#id--checkout__accordion-collapse-billing').collapse('show');
                }

            });
        },

        addGuestMail() {

            this.guestMailDisabled = true;

            if (this.isMail(this.guestMail)) {
                ApiService
                    .post('/rest/io/guest', {email: this.guestMail})
                    .done(function () {

                        NotificationService.success(
                            TranslationService.translate('ODFashioncode::Fashioncode.checkoutEmailAdded')
                        ).closeAfter(3000);

                        this.noGuestMail = false;

                        if (this.isChange) {
                            $('#id--checkout__accordion-collapse-shipping').collapse('show');
                            $('#id--checkout__accordion-collapse-payment').collapse('show');
                            $('#id--checkout__accordion-collapse-order').collapse('show');
                            $('#id--checkout__accordion-collapse-billing').collapse('show');
                        } else {
                            $('#id--checkout__accordion-collapse-billing').collapse('show');
                        }

                    }.bind(this));
            } else {
                NotificationService.error(
                    TranslationService.translate('ODFashioncode::Fashioncode.checkoutInvalidEmail')
                )
            }

            this.guestMailDisabled = false;
        },

        changeMail() {

            if (this.isLoggedIn) {
                NotificationService.success('Bitte loggen Sie sich in Ihrem Kundenkonto aus und anschließend wieder ein')
            } else {

                this.noGuestMail = true;
                this.isChange = true;

                $('#id--checkout__accordion-collapse-shipping').collapse('hide');
                $('#id--checkout__accordion-collapse-payment').collapse('hide');
                $('#id--checkout__accordion-collapse-order').collapse('hide');
                $('#id--checkout__accordion-collapse-billing').collapse('hide');
            }

        },

        isMail(mail) {

            const mailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

            return mailRegEx.test(mail);
        }
    }
});
